export const ExternalLogsData = [
    {
        id: 333333,
        subscriptionId: 17231,
        timeLogged: 1234567890,
        country: 'Nigeria',
        ip: '192.168.68.212',
        timeCreated: 1725966442,
        successStatus: 'success',
        status: 'active',
        userAgent: 'Mozilla/5.0',
        demo: true
    },
    {
        id: 22222,
        subscriptionId: 17241,
        timeLogged: 1234567890,
        country: 'Nigeria',
        ip: '192.168.68.212',
        timeCreated: 1725966456,
        successStatus: 'success',
        status: 'active',
        userAgent: 'Mozilla/5.0',
        demo: true
    }
];

export default null;
